import React, { Fragment } from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import { getFinalStatusWithModifiedDrStatuses } from "helpers/common";
import { lookupTable } from "data/data";

const styles = StyleSheet.create({
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    width: "120%",
    gap: "1%",
    marginBottom: "6px",
    fontSize: "13",
  },
  image: {
    width: 60,
    height: 60,
    display: "flex",
    cursor: "pointer",
  },
  patientName: {
    width: "39%",
    textAlign: "left",
    padding: "10px",
    fontSize: "12px",
  },
  status: {
    width: "39%",
    textAlign: "left",
    fontSize: "12px",
    padding: "10px",
  },
});

const TableRow = ({ items }) => {
  console.log("Table ROw", items);
  const rows = items?.map((row, index) => (
    <View style={styles.row} key={index}>
      <Image
        style={styles.image}
        source={row?.thumbnailUrl}
        title={row?.info?.orignalName}
        alt={row?.info?.orignalName}
      />
      <Text style={styles.patientName}>
        {row?.info?.orignalName !== "" ? (
          <p>{row?.info?.orignalName}</p>
        ) : (
          <p>id: {row?.info?.guid}</p>
        )}
      </Text>
      <Text style={styles.status}>
        {typeof row?.status !== "string"
          ? getFinalStatusWithModifiedDrStatuses(row?.status, lookupTable, [])
          : row?.status}
      </Text>
    </View>
  ));
  return <Fragment>{rows}</Fragment>;
};

export default TableRow;
